import * as React from "react";
import {Alert, Button, Row, Col, Card, Tabs, Tab} from "react-bootstrap";
import { Link, withRouter, RouteComponentProps} from "react-router-dom";
import { connect } from "react-redux";
import withRequestState from "../../../components/WithRequestState";
import { RequestStateProps } from "../../../interfaces/RequestState";
import { State } from "../../../interfaces/State";
import User from "../../../interfaces/User";
import { getUser } from "../../../redux/users/selectors";
import { getUsers } from "../../../redux/users/actions";

interface IProps {
    user: User;
    getUsers: () => void;
}

interface RouteParams {
    id: string;
}

class UserPage extends React.Component<IProps & RequestStateProps & RouteComponentProps<RouteParams>> {

    componentDidMount(){
        if (this.props.user == null){
            this.props.getUsers();
        }
    }

    render(){
        return (
            <div className="main-page p-3">
                <h4>People</h4>

                <Link to="/people" className="d-flex align-items-center">
                    Back to list
                </Link>

                <Card>
                    <Card.Body>

                        <div>
                            <Row>
                                <Col>
                                    Picture
                                </Col>
                                <Col>
                                    <h4>{this.props.user.name}</h4>
                                    {
                                        this.props.user.contractor ? <p>{this.props.user.contractor.name}</p> : null
                                    }
                                </Col>
                                <Col>
                                    QR Code
                                </Col>
                            </Row>
                        </div>

                        <Tabs defaultActiveKey="summary" id="tabs">
                            <Tab eventKey="summary" title="summary"></Tab>
                            <Tab eventKey="timesheets" title="timesheets"></Tab>
                            <Tab eventKey="activity" title="activity"></Tab>
                            <Tab eventKey="details" title="Personal details">

                                <Row>
                                    <Col><p className="font-weight-bold">Email:</p></Col>
                                    <Col>{this.props.user.email}</Col>
                                </Row>

                                <Row>
                                    <Col><p className="font-weight-bold">Phone:</p></Col>
                                    <Col>{this.props.user.phoneNumber}</Col>
                                </Row>

                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>

            </div>
        )
    }

}


export default withRouter(connect((state : State, props) => ({
    user: getUser(state, props)
}), ({
    getUsers
}))(withRequestState(UserPage, [])));